/* FTP Endurance Fuel — conversion section pack behaviour.
   Quick add to cart, the fuel planner, the sticky mobile CTA and the preview-only email form. */
(function () {
  if (window.__ftpCro) return;
  window.__ftpCro = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Toast ---------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'ftp-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  /* ---------- Quick add ----------
     Any element with data-ftp-add="<variant id>" adds to the cart with the AJAX API,
     then refreshes the theme's cart count. data-ftp-after="cart" sends the shopper to /cart instead.
     16 Oct 2026: the quantity now follows the product's quantity rule. Trade (B2B) buyers have minimums and
     multiples (1kg pastilles in 10s, Power Fluids 900g in 20s, electrolyte tubes in 12s), and the fixed
     quantity of 1 these buttons used to send was refused ("This item has a minimum of 10"), even after the
     agent had typed 50 in the Quantity box. The quantity is now:
       1. on a product page, for that product: whatever is in the Quantity box, rounded to the rule;
       2. otherwise data-ftp-qty on the button (product cards print the rule's minimum there);
       3. otherwise 1 (every retail product).
     If the cart still refuses the add, the shopper is taken to the product page, where the Quantity box applies the rule. */
  function snapQty(q, min, step) {
    min = Math.max(1, Math.floor(Number(min) || 1));
    step = Math.max(1, Math.floor(Number(step) || 1));
    q = Math.floor(Number(q) || 0);
    if (q < min) return min;
    return min + Math.floor((q - min) / step) * step;
  }
  function quickQty(btn, id) {
    var q = Math.max(1, Math.floor(Number(btn.getAttribute('data-ftp-qty')) || 1));
    var boxes = document.querySelectorAll('#MainContent input.quantity__input[name="quantity"]');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i], f = box.form, v = f && f.querySelector('[name="id"]');
      if (v && String(v.value) === String(id)) {
        return snapQty(box.value, box.getAttribute('min') || box.getAttribute('data-min'), box.getAttribute('step'));
      }
    }
    return q;
  }

  function refreshCartCount() {
    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble span, .header__cart-count').forEach(function (el) {
        el.textContent = cart.item_count;
      });
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart, bubbles: true }));
      document.dispatchEvent(new CustomEvent('ftp:cart-updated', { detail: cart, bubbles: true }));
    }).catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ftp-add]');
    if (!btn || !window.Shopify) return; // outside Shopify the button is a plain product link
    var id = btn.getAttribute('data-ftp-add');
    if (!id) return;
    e.preventDefault();
    btn.setAttribute('aria-busy', 'true');
    var sellingPlan = btn.getAttribute('data-selling-plan');
    var qty = quickQty(btn, id);
    var item = { id: Number(id), quantity: qty };
    if (sellingPlan) item.selling_plan = Number(sellingPlan);
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add to cart'); });
      return r.json();
    }).then(function () {
      if (btn.getAttribute('data-ftp-after') === 'cart') { window.location.href = root + 'cart'; return; }
      refreshCartCount();
      toast(qty > 1 ? 'Added ' + qty + ' to your cart' : 'Added to your cart');
    }).catch(function (err) {
      toast(err.message || 'Could not add to cart. Try the product page.');
      var href = btn.getAttribute('href') || '';
      if (/\/products\//.test(href) && href.split('?')[0] !== location.pathname) {
        setTimeout(function () { window.location.href = href; }, 1800);
      }
    }).finally(function () {
      btn.removeAttribute('aria-busy');
    });
  });

  // Sticky bar on products with flavours: take the shopper back up to the picker
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-ftp-scrolltop]')) return;
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  /* ---------- Fuel planner ----------
     Guidance bands follow current sports-nutrition consensus:
     under 1h little or no carbohydrate is needed, 1–2.5h 30–60g/h, beyond 2.5h 60–90g/h.
     Running sits slightly lower than riding because of gut jostle; faster athletes at higher
     intensity can use more. Delivery is split between bottle and pocket by how the athlete likes
     to fuel and what they can carry. The recommendation walks the range: tasters or a 1kg pack for
     short sessions, electrolytes added for salty sweaters, the Long Session Stack for long days,
     the Race Week Kit for race day, and the System or a Rotation Pack for big weekly volume. */
  var CARB_PER_SCOOP = 27, NA_PER_SCOOP = 300, CARB_PER_CHEW = 15, NA_PER_TAB = 300;

  function plan(input) {
    var h = input.hours, carbs, pace = Number(input.pace) || 2;
    if (h < 1) carbs = 20;
    else if (h < 1.5) carbs = 40;
    else if (h < 2.5) carbs = 60;
    else if (h < 4) carbs = 75;
    else carbs = 85;
    carbs += { easy: -15, steady: 0, race: 10 }[input.intensity] || 0;
    carbs += { 1: -10, 2: 0, 3: 5, 4: 10 }[pace] || 0;
    if (input.sport === 'run') carbs -= 10;
    carbs = Math.max(30, Math.min(90, Math.round(carbs / 5) * 5));
    if (h < 1) carbs = (input.intensity === 'race' || pace >= 4) ? 30 : 0;

    var sweat = { light: { na: 300, ml: 400 }, average: { na: 500, ml: 550 }, heavy: { na: 800, ml: 750 } }[input.sweat] || { na: 500, ml: 550 };
    var cap = { pockets: 0, bottle: 1, vest: 2 }[input.carry];
    if (cap === undefined) cap = 1;

    var scoops = 0;
    // Short sessions on 'bit of both': water in the bottle, pastilles for the carbs
    var skipBottle = input.pref === 'mix' && h < 1.5;
    if (carbs > 0 && cap > 0 && input.pref !== 'chew' && !skipBottle) {
      if (input.pref === 'drink') scoops = cap;
      else scoops = Math.max(1, Math.min(cap, Math.round(sweat.ml / 500)));
      while (scoops > 0 && scoops * CARB_PER_SCOOP > carbs + 5) scoops--;
    }
    var chews = Math.max(0, Math.round((carbs - scoops * CARB_PER_SCOOP) / CARB_PER_CHEW));
    var naLeft = sweat.na - scoops * NA_PER_SCOOP;
    var tabs = naLeft >= 450 ? 2 : naLeft >= 250 ? 1 : 0;
    if (h < 1.5 && input.sweat !== 'heavy') tabs = 0;
    if (tabs) tabs = Math.min(tabs, Math.max(1, cap - scoops));

    return {
      carbs: carbs, sodium: sweat.na, fluid: sweat.ml, scoops: scoops, chews: chews, tabs: tabs, cap: cap,
      salty: input.sweat === 'heavy',
      totalCarbs: Math.round(carbs * h), totalChews: Math.ceil(chews * h), totalScoops: Math.ceil(scoops * h)
    };
  }
  window.ftpFuelPlan = plan;

  function pickKit(input, p, recs) {
    var h = input.hours, vol = Number(input.volume) || 4.5;
    var chew = p.chews > 0, drink = p.scoops > 0;
    var key, addon = null;
    if (p.carbs === 0) key = vol < 3 ? 'tasters' : 'pastilles';
    else if (vol >= 8) key = chew && drink ? 'system' : chew ? 'rotation' : 'fluids_rotation';
    else if (input.intensity === 'race') key = 'raceweek';
    else if (h >= 2) key = chew && drink ? 'long' : chew ? 'pastilles' : 'fluids';
    else if (drink && (!chew || input.pref === 'drink')) key = 'fluids';
    else key = vol < 3 ? 'tasters' : 'pastilles';
    var chain = { fluids_rotation: ['fluids', 'system'], rotation: ['pastilles', 'system'], system: ['long'], raceweek: ['long'], tasters: ['starter'], pastilles: ['starter'], fluids: ['starter'], long: ['starter'] };
    var tryKeys = [key].concat(chain[key] || []).concat(['starter']);
    for (var i = 0; i < tryKeys.length; i++) if (recs[tryKeys[i]]) { key = tryKeys[i]; break; }
    // Add-on line. Salty sweaters get electrolytes where the kit has no drink mix.
    if (p.salty && ['tasters', 'pastilles', 'rotation', 'long', 'starter'].indexOf(key) > -1 && recs.electrolytes) addon = 'electrolytes';
    // Everyone else gets the pouch or bottle the kit doesn't already include.
    if (!addon) {
      var kitHas = { starter: ['pouch'], long: ['bottle', 'pouch'], raceweek: ['bottle', 'pouch'], system: ['bottle', 'pouch'], fluids_rotation: ['bottle'] };
      var has = kitHas[key] || [];
      var bottleFirst = key === 'fluids' || key === 'fluids_rotation' || input.pref === 'drink';
      var gear = bottleFirst ? ['bottle', 'pouch'] : ['pouch', 'bottle'];
      for (var g = 0; g < gear.length; g++) if (has.indexOf(gear[g]) < 0 && recs[gear[g]]) { addon = gear[g]; break; }
    }
    return { key: key, rec: recs[key], addon: addon && recs[addon] ? recs[addon] : null };
  }

  function fmtHours(h) {
    var hh = Math.floor(h), mm = Math.round((h - hh) * 60);
    return hh + 'h' + (mm ? ' ' + (mm < 10 ? '0' : '') + mm + 'm' : '');
  }

  function fillRec(box, rec) {
    if (!box) return;
    if (!rec) { box.hidden = true; return; }
    box.hidden = false;
    var img = box.querySelector('img');
    img.src = rec.image || img.src;
    img.alt = rec.title;
    box.querySelector('.ftp-rec__name').textContent = rec.title;
    box.querySelector('.ftp-rec__why').textContent = rec.why || '';
    var b = box.querySelector('.ftp-btn');
    b.href = rec.url;
    b.querySelector('[data-out="price"]').textContent = rec.price;
    if (rec.variant) b.setAttribute('data-ftp-add', rec.variant); else b.removeAttribute('data-ftp-add');
  }

  function initPlanner(el) {
    var form = el.querySelector('form');
    var recs = {};
    try { recs = JSON.parse(el.querySelector('[data-ftp-recs]').textContent); } catch (e) {}
    var xl = el.getAttribute('data-extra-life');
    var $ = function (s) { return el.querySelector(s); };
    var last = null;

    function paceLabels(sport) {
      var mode = sport === 'run' ? 'run' : 'ride';
      el.querySelectorAll('[data-ftp-pace-legend], label[data-run]').forEach(function (n) {
        var t = n.getAttribute('data-' + mode);
        if (t) n.textContent = t;
      });
    }

    function render() {
      var fd = new FormData(form);
      var input = {
        sport: fd.get('sport'), intensity: fd.get('intensity'), sweat: fd.get('sweat'),
        hours: parseFloat(fd.get('hours')), pace: fd.get('pace'), volume: fd.get('volume'),
        pref: fd.get('pref'), carry: fd.get('carry')
      };
      paceLabels(input.sport);
      var p = plan(input);
      $('[data-out="hours"]').textContent = fmtHours(input.hours);
      $('[data-out="carbs"]').textContent = p.carbs;
      $('[data-out="sodium"]').textContent = p.sodium;
      $('[data-out="fluid"]').textContent = p.fluid;

      var rows = [];
      if (p.carbs === 0) {
        rows.push(['Bottle', 'Water is enough under an hour at this effort.' + (p.salty ? ' You sweat salty, so drop an Electrolyte Tablet in it.' : '')]);
        rows.push(['After', 'Keep a pack of pastilles in the bag for when the sessions get longer.']);
      } else {
        if (p.scoops) rows.push(['Bottle', p.scoops + ' scoop' + (p.scoops > 1 ? 's' : '') + ' of Power Fluids per hour in ' + p.fluid + 'ml (' + p.scoops * CARB_PER_SCOOP + 'g carbs, ' + p.scoops * NA_PER_SCOOP + 'mg sodium)']);
        if (p.chews) rows.push(['Pocket', p.chews + ' Energy Pastille' + (p.chews > 1 ? 's' : '') + ' per hour, one every ' + Math.round(60 / p.chews) + ' min (' + p.chews * CARB_PER_CHEW + 'g carbs)']);
        if (p.cap === 0) rows.push(['Fluid', 'No bottle, so drink about ' + p.fluid + 'ml an hour at stops or aid stations' + (input.pref === 'drink' ? '. Pastilles carry the carbs when you can\'t carry a drink.' : '.')]);
        if (p.tabs) rows.push(['Salt', p.cap === 0 ? 'Have an Electrolyte Tablet in water before you go and at any stop, to get nearer ' + p.sodium + 'mg sodium an hour.' : p.tabs + ' Electrolyte Tablet' + (p.tabs > 1 ? 's' : '') + ' in water each hour to reach ' + p.sodium + 'mg sodium']);
        rows.push(['Session', 'About ' + p.totalCarbs + 'g carbs in total' + (p.totalScoops ? ': ' + p.totalScoops + ' scoop' + (p.totalScoops === 1 ? '' : 's') : ':') + (p.totalScoops && p.totalChews ? ' and ' : ' ') + (p.totalChews ? p.totalChews + ' pastille' + (p.totalChews === 1 ? '' : 's') : '')]);
        if (xl && (input.hours >= 2.5 || input.intensity === 'race')) rows.push(['Back pocket', 'One Extra Life for the bad patch: 50g carbs, 100mg caffeine and 150mg sodium in one hit. <a href="' + xl + '">Landing in November</a>']);
      }
      $('[data-out="plan"]').innerHTML = rows.map(function (r) {
        return '<li><span>' + r[0] + '</span><div>' + r[1] + '</div></li>';
      }).join('');

      var kit = pickKit(input, p, recs);
      last = { input: input, plan: p, rows: rows, rec: kit.rec, key: kit.key, addon: kit.addon };
      fillRec($('[data-out="rec"]'), kit.rec);
      fillRec($('[data-out="addon"]'), kit.addon);
    }
    form.addEventListener('input', render);
    form.addEventListener('change', render);
    form.addEventListener('submit', function (e) { e.preventDefault(); });
    render();

    var cap = el.querySelector('[data-ftp-plancap]');
    if (cap) cap.addEventListener('submit', function (e) {
      e.preventDefault();
      sendPlan(cap, last);
    });
  }

  /* ---------- "Email me my plan" ----------
     Subscribes the shopper to a Klaviyo list (source "Fuel planner") with Klaviyo's public client API,
     then records a "Requested Fuel Plan" event carrying the plan so a Klaviyo flow can email it.
     This sits alongside the Klaviyo popup; it does not replace it. */
  var SPORT_NAMES = { run: 'Running', ride: 'Cycling', tri: 'Triathlon' };

  function sendPlan(cap, last) {
    var msg = cap.querySelector('.ftp-msg');
    var input = cap.querySelector('input[type=email]');
    var email = input.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      msg.className = 'ftp-msg ftp-msg--err';
      msg.textContent = 'Enter an email address like name@example.com.';
      input.focus();
      return;
    }
    if (!last) return;
    var company = cap.getAttribute('data-company');
    var list = cap.getAttribute('data-list');
    var p = last.plan, i = last.input;
    var props = {
      fuel_plan_sport: SPORT_NAMES[i.sport] || i.sport,
      fuel_plan_hours: i.hours,
      fuel_plan_intensity: i.intensity,
      fuel_plan_sweat: i.sweat,
      fuel_plan_carbs_per_hour: p.carbs,
      fuel_plan_sodium_per_hour: p.sodium,
      fuel_plan_fluid_per_hour: p.fluid,
      fuel_plan_pace: i.pace,
      fuel_plan_weekly_hours: i.volume,
      fuel_plan_preference: i.pref,
      fuel_plan_carry: i.carry
    };
    var eventProps = Object.assign({}, props, {
      plan_lines: last.rows.map(function (r) { return r[0] + ': ' + r[1].replace(/<[^>]+>/g, ''); }),
      total_carbs: p.totalCarbs,
      recommended_kit: last.rec ? last.rec.title : '',
      recommended_url: last.rec ? new URL(last.rec.url, location.origin).href : '',
      recommended_addon: last.addon ? last.addon.title : ''
    });
    var headers = { 'Content-Type': 'application/json', revision: '2024-10-15' };
    var base = 'https://a.klaviyo.com/client/';
    var q = '?company_id=' + encodeURIComponent(company);
    var btn = cap.querySelector('button');
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;

    fetch(base + 'subscriptions/' + q, {
      method: 'POST', headers: headers,
      body: JSON.stringify({ data: { type: 'subscription', attributes: {
        custom_source: 'Fuel planner',
        profile: { data: { type: 'profile', attributes: {
          email: email, properties: props,
          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
        } } }
      }, relationships: { list: { data: { type: 'list', id: list } } } } })
    }).then(function (r) {
      if (!r.ok) throw new Error('subscribe ' + r.status);
      return fetch(base + 'events/' + q, {
        method: 'POST', headers: headers,
        body: JSON.stringify({ data: { type: 'event', attributes: {
          properties: eventProps,
          metric: { data: { type: 'metric', attributes: { name: 'Requested Fuel Plan' } } },
          profile: { data: { type: 'profile', attributes: { email: email } } }
        } } })
      });
    }).then(function () {
      try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email }); } catch (err) {}
      msg.className = 'ftp-msg ftp-msg--ok';
      msg.textContent = 'Done. Your ' + p.carbs + 'g/hr plan is on its way to ' + email + '.';
      cap.classList.add('is-sent');
    }).catch(function () {
      msg.className = 'ftp-msg ftp-msg--err';
      msg.textContent = 'That didn’t go through. Check your connection and try again.';
    }).finally(function () {
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
    });
  }

  /* ---------- Same-day dispatch countdown ----------
     Counts down to the cut-off hour in UK time (Europe/London), every day of the week. */
  function londonNow() {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' })
      .formatToParts(new Date()).forEach(function (x) { parts[x.type] = x.value; });
    return Number(parts.hour) * 60 + Number(parts.minute);
  }

  function initDispatch(el) {
    var cutoff = Number(el.getAttribute('data-cutoff')) * 60;
    var label = el.getAttribute('data-cutoff-label');
    var text = el.querySelector('[data-ftp-dispatch-text]');
    function tick() {
      var left = cutoff - londonNow();
      if (left > 0) {
        var h = Math.floor(left / 60), m = left % 60;
        var t = (h ? h + 'h ' : '') + m + 'm';
        text.innerHTML = 'Order within <b>' + t + '</b> for same-day dispatch';
        el.classList.remove('is-tomorrow');
      } else {
        text.innerHTML = 'Order now for dispatch <b>tomorrow</b>. Last dispatch ' + label + ', every day';
        el.classList.add('is-tomorrow');
      }
    }
    tick();
    setInterval(tick, 30000);
  }

  /* ---------- Sticky mobile CTA ---------- */
  function initSticky(bar) {
    var view = bar.closest('[data-ftp-view]');
    var trigger = (view && view.querySelector('[data-ftp-sticky-after]')) ||
      document.querySelector('[data-ftp-sticky-after]') ||
      document.querySelector('.ftp-hero, .product-section, [id$="__main-product"], [id$="__main"]');
    if (!trigger || !('IntersectionObserver' in window)) { bar.classList.add('is-on'); return; }
    new IntersectionObserver(function (entries) {
      var past = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      bar.classList.toggle('is-on', past);
    }).observe(trigger);
  }

  /* ---------- Preview-only email form (Shopify uses the native customer form) ---------- */
  function initDemoForm(form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var msg = form.querySelector('.ftp-msg');
      var email = form.querySelector('input[type=email]').value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        msg.className = 'ftp-msg ftp-msg--err';
        msg.textContent = 'Enter an email address like name@example.com.';
        return;
      }
      msg.className = 'ftp-msg ftp-msg--ok';
      msg.textContent = 'Preview only. On your store this adds the address to Shopify customers and Klaviyo.';
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-ftp-planner]').forEach(function (el) { if (!el._ftp) { el._ftp = 1; initPlanner(el); } });
    (scope || document).querySelectorAll('[data-ftp-sticky]').forEach(function (el) { if (!el._ftp) { el._ftp = 1; initSticky(el); } });
    (scope || document).querySelectorAll('form[data-ftp-demo]').forEach(function (el) { if (!el._ftp) { el._ftp = 1; initDemoForm(el); } });
    (scope || document).querySelectorAll('[data-ftp-dispatch]').forEach(function (el) { if (!el._ftp) { el._ftp = 1; initDispatch(el); } });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  // Re-initialise when sections are added or edited in the theme editor
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
